var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgOutlineCopy2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 51,
    viewBox: "0 0 50 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "OUTLINE_copy_2"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 3",
    cx: 25,
    cy: 25.5458,
    r: 25,
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M25 0.545776C11.1937 0.545776 0 11.7395 0 25.5458C0 39.352 11.1937 50.5458 25 50.5458C38.8063 50.5458 50 39.352 50 25.5458C50 11.7395 38.8063 0.545776 25 0.545776ZM30.45 25.5442H26.9516V38.238H21.7063V25.5458H19.0859V21.1708H21.7063V18.5442C21.7063 14.9755 23.1859 12.8536 27.3891 12.8536H30.8891V17.2286H28.7016C27.0656 17.2286 26.9563 17.8411 26.9563 18.9802L26.9516 21.1708H30.9141L30.45 25.5442Z",
    fill: "#D29191"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOutlineCopy2);
export default __webpack_public_path__ + "static/media/OUTLINE_copy_2.d7ed5be90a21b935aadf3e79e538ac52.svg";
export { ForwardRef as ReactComponent };